import * as actionTypes from "../actionTypes/actionTypes";
import {
  getDiscountsOfferedService,
  createDiscountsOfferedService,
  updateDiscountsOfferedService,
  deleteDiscountsOfferedService
  } from "../services/DiscountsOfferedService";
  import * as _ from "lodash";
const getDiscountsOffered = (sales) => {
    return async(dispatch) => {
        dispatch({
            type: actionTypes.GET_DISCOUNT_OFFERED
        })
        window.startLoading();
        getDiscountsOfferedService(sales)
        .then((response)=>{
          const data = response.data;
          const sortedDiscountsOffered = _.sortBy(data, ['discountLabel']);
            dispatch({
                type: actionTypes.GET_DISCOUNT_OFFERED_SUCCESS,
                payload: sortedDiscountsOffered
            })
        })
        .catch((error)=>{
          dispatch({
            type: actionTypes.GET_DISCOUNT_OFFERED_FAILURE,
            payload: error
        })
        }).finally(()=>{
          window.stopLoading();
        })
    }
}


const createDiscountsOffered = (requestPayload) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.CREATE_DISCOUNT_OFFERED,
    });
    window.startLoading();
    await createDiscountsOfferedService(requestPayload)
      .then((response) => {
        const data = response.data;
        dispatch({
          type: actionTypes.CREATE_DISCOUNT_OFFERED_SUCCESS,
          payload: data,
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.CREATE_DISCOUNT_OFFERED_FAILURE,
          payload: error,
        });
      }).finally(()=>{
        window.stopLoading();
      })
  };
};

const updateDiscountsOffered = (discountOfferedId,requestPayload) => {
  return async (dispatch) => {
    dispatch({
      type: actionTypes.UPDATE_DISCOUNT_OFFERED,
    });
    window.startLoading();
    await updateDiscountsOfferedService(discountOfferedId, requestPayload)
      .then((response) => {
        const data = response.status;
        dispatch({
          type: actionTypes.UPDATE_DISCOUNT_OFFERED_SUCCESS,
          payload: data,
          discountOfferedId: discountOfferedId
        });
      })
      .catch((error) => {
        dispatch({
          type: actionTypes.UPDATE_DISCOUNT_OFFERED_FAILURE,
          payload: error,
        });
      })
      .finally(() => {
        window.stopLoading();
      });
  };
};

const deleteDiscountsOffered = (requestPayload) => {
  return async(dispatch) => {
      dispatch({
          type: actionTypes.DELETE_TOOL
      })
      window.startLoading();
      await deleteDiscountsOfferedService(requestPayload)
      .then((response) => {
          const data = response.status;
          dispatch({
              type: actionTypes.DELETE_TOOL_SUCCESS,
              payload: data
          })
      })
      .catch((error) => {
          dispatch({
              type: actionTypes.DELETE_TOOL_FAILURE,
              payload: error
          })
      }).finally(()=>{
        window.stopLoading();
      });
  }
}

const getDiscountsOfferedListData = (discountOfferedListData) => {
  return async(dispatch) => {
    dispatch({
      type: actionTypes.RENDER_DISCOUNT_OFFERED_LIST_DATA,
      payload:discountOfferedListData
    })
  }
}

export { getDiscountsOffered, createDiscountsOffered, updateDiscountsOffered, deleteDiscountsOffered, getDiscountsOfferedListData };
